import React from "react";
// import { Search } from "@mui/icons-material";
import {
  Autocomplete,
  Button,
  Container,
  Grid,
  List,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import LaunchIcon from "@mui/icons-material/Launch";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import "./Scheduled.css";
import Excel from "../../img/excel.png";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#fff",
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  right: "0",
  color: "#2A3478",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

const ScheduledMetingHeader = ({
  ownerList,
  fromDate,
  setFromDate,
  toDate,
  setToDate,
  statusId,
  setStatusId,
  clientId,
  setClientId,
  showFilteredData,
  statusData,
  exportHandler,
  selectOptonCustomer,
}) => {
  const Status = [
    { id: "COMPLETED", name: "COMPLETED" },
    { id: "SCHEDULED", name: "SCHEDULED" },
    { id: "RESCHEDULED", name: "RESCHEDULED" },
    { id: "SCHEDULE_RESCHEDULED", name: "SCHEDULE_RESCHEDULED" },
    { id: "CANCELLED", name: "CANCELLED" },
    { id: "MISSED", name: "MISSED" },
  ];

  const getclientId = (e) => {
    if (e !== null) {
      setClientId(e);
    } else {
      setClientId();
    }
  };

  return (
    <Box sx={{ paddingBottom: "8px", marginTop: "16px" }} maxWidth="true">
      <Grid
        container
        // spacing={1}
        // style={{ placeItems: "center", justifyContent: "end" }}
      >
        {/* <Grid container xs={12}>
          <Grid item xs={4}>
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                color: "#2A3478",
                fontSize: "23px",
              }}
            >
              Scheduled List
            </Typography>
          </Grid>
          <Grid item xs={8} container justifyContent="flex-end">
            <Box className="top_fields" display={"flex"} gap="5px">
              <div
                className="fieldBox"
                style={{
                  backgroundColor: "rgb(61 61 122)",
                  color: "#fff",
                }}
              >
                <span>Total</span>
                <span className="count">
                  {statusData ? statusData.totalCommFollowUp : 0}
                </span>
              </div>
              <div
                className="fieldBox"
                style={{
                  backgroundColor: "#32a472",
                  color: "#fff",
                }}
              >
                <span>Total Completed </span>
                <span className="count">
                  {statusData ? statusData.totalCompletedCommFollowUp : 0}
                </span>
              </div>
              <div
                className="fieldBox"
                style={{
                  backgroundColor: "rgb(212 199 43)",
                  color: "#fff",
                }}
              >
                <span>Total Scheduled </span>
                <span className="count">
                  {statusData ? statusData.totalScheduledCommFollowUp : 0}
                </span>
              </div>
              <div
                className="fieldBox"
                style={{
                  backgroundColor: "#2bd4b5",
                  color: "#fff",
                }}
              >
                <span>Total Rescheduled </span>
                <span className="count">
                  {statusData ? statusData.totalRescheduledCommFollowUp : 0}
                </span>
              </div>
              <div
                className="fieldBox"
                style={{
                  backgroundColor: "#e94b61",
                  color: "#fff",
                }}
              >
                <span>Missed </span>
                <span className="count">
                  {statusData ? statusData.totalMissedCommFollowUp : 0}
                </span>
              </div>
            </Box>
          </Grid>
        </Grid> */}
        <Grid item xs={12}>
          <Box className="top_fields" display={"flex"} gap="3px">
            <div
              className="field_box calender"
              style={{ alignItems: "inherit" }}
            >
              <span>From</span>
              <TextField
                name="fromDate"
                type="date"
                size="small"
                variant="outlined"
                //inputProps={{ max: toDate }}
                value={fromDate}
                onChange={(e) => {
                  setFromDate(e.target.value);
                }}
              />
            </div>
            <div
              className="field_box calender"
              style={{ alignItems: "inherit" }}
            >
              <span>To</span>
              <TextField
                name="fromDate"
                type="date"
                size="small"
                variant="outlined"
                //inputProps={{ max: toDate }}
                value={toDate}
                onChange={(e) => {
                  setToDate(e.target.value);
                }}
              />
            </div>
            <div className="field_box">
              <Autocomplete
                size="small"
                id="header"
                className="select_box"
                options={ownerList || []}
                getOptionLabel={(option) => `${option.name}(${option.empCode})`}
                disablePortal={true}
                fullWidth
                onChange={(event, newValue) => {
                  getclientId(newValue);
                }}
                renderOption={(props, option) => {
                  return (
                    <List
                      sx={{ opacity: option.userId == 0 ? ".5" : "1" }}
                      {...props}
                      key={option.userId}
                    >
                      {`${option.name}(${option.empCode})`}
                    </List>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    placeholder={
                      selectOptonCustomer !== ""
                        ? selectOptonCustomer
                        : // : "Select Client Owner"
                          "Select Employee Name"
                    }
                  />
                )}
              />
            </div>
            <div className="field_box">
              <Autocomplete
                size="small"
                id="header"
                className="select_box"
                options={Status || []}
                getOptionLabel={(option) => `${option.name}`}
                disablePortal={true}
                //fullWidth
                onChange={(event, newValue) => {
                  setStatusId(newValue);
                }}
                renderOption={(props, option) => {
                  return (
                    <List
                      sx={{ opacity: option.userId == 0 ? ".5" : "1" }}
                      {...props}
                      key={option.userId}
                    >
                      {`${option.name}`}
                    </List>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    placeholder="Status"
                  />
                )}
              />
            </div>
            <div className="field_box">
              <div
                className="field_box_btn"
                onClick={showFilteredData}
                style={{
                  cursor: "pointer",
                }}
              >
                Go
              </div>
            </div>
            {/* <Button variant="outlined" startIcon={<LaunchIcon />} className="field_box btn client"> */}
            <div style={{ display: "none" }}>
              <ReactHTMLTableToExcel
                id="clientExport"
                className="exportBtn"
                table="FlowUpTable"
                filename="FollowUp"
                sheet="Client Details"
                buttonText="Export"
              />
            </div>

            <Tooltip
              title="Export Excel"
              sx={{ width: "35px", height: "15px" }}
              onClick={() => exportHandler()}
            >
              <img
                src={Excel}
                style={{
                  width: "30px",
                  marginTop: "2px",
                  cursor: "pointer",
                }}
                alt=""
              />
            </Tooltip>
            {/* <div className="field_box btn client">
              <Button variant="outlined" startIcon={<LaunchIcon />}>
                Export
              </Button> */}
            {/* </Button>  */}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ScheduledMetingHeader;
